import { render } from "./illuminationPhotonMixer.vue?vue&type=template&id=06a1c45b&scoped=true"
import script from "./illuminationPhotonMixer.vue?vue&type=script&lang=js"
export * from "./illuminationPhotonMixer.vue?vue&type=script&lang=js"

import "./illuminationPhotonMixer.vue?vue&type=style&index=0&id=06a1c45b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a1c45b"]])

export default __exports__